import "../../styles/Gantt.css";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import store from "../../store";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

const FractionOfYear = (dateStart, dateEnd) => {
    const diffTime = Math.abs(dateEnd - dateStart);
    const fraction = diffTime / (1000 * 60 * 60 * 24) / 365;
    return fraction;
}

export default function GanttMyc({ tasks, startYear, endYear }) {
    let htmlTasks = [];
    const [widthYear] = useState(
        store.getState().ganttSumpManagement.widthYear,
    );
    let widthYearHeader = widthYear - 1; // 1 for the border
    const { t } = useTranslation();

    // Years
    let htmlYears = [];
    for (let year = startYear; year < endYear; year++) {
        htmlYears.push(
            <div
                className="gantt-header-cell-year"
                style={{ width: widthYearHeader, minWidth: widthYearHeader }}
                key={year}
            >
                {year}
            </div>,
        );
    }
    htmlTasks.push(
        <div className="gantt-task-year gantt-header-year">{htmlYears}</div>,
    );

    // Tasks
    tasks.forEach(function (task) {
        let htmlTask = "";
        if (task.isAction === "True") {
            htmlTask = (
                <div
                    className="gantt-action"
                    style={{ background: task.styles.backgroundColor }}
                >
                    {t(`SUMP Management Content.tasks.${task.name}`)}
                </div>
            );
        } else {
            let dateStart = new Date(task.start);
            let dateEnd = new Date(task.end);

            let nbYears = FractionOfYear(dateStart, dateEnd);
            let htmlYears = [];

            let fractionStartYear = FractionOfYear(new Date(startYear, 0, 1, 0, 0, 0, 0), dateStart);
            let widthContainer = (nbYears) * widthYear
            let styleContainer = {
                marginLeft: fractionStartYear * widthYear,
                width: widthContainer,
                minWidth: widthContainer,
            };
            let widthContainerProgressReal = (((nbYears) * task.progressReal) / 100) * widthYear;
            let styleContainerProgressReal = {
                width: widthContainerProgressReal,
                minWidth:widthContainerProgressReal,
                background: task.styles.progressRealColor,
            };
            let widthBeforeProgress = (((nbYears) * task.progress) / 100) * widthYear;
            let styleBeforeProgress = {
                backgroundImage:
                    "linear-gradient(45deg, " +
                    task.styles.progressColor +
                    " 5%, #fff 5%, #fff 45%, " +
                    task.styles.progressColor +
                    " 45%, " +
                    task.styles.progressColor +
                    " 55%, #fff 55%, #fff 95%, " +
                    task.styles.progressColor +
                    " 95%)",
                width: widthBeforeProgress,
                minWidth: widthBeforeProgress,
            };
            let widthAfterProgress = (nbYears - ((nbYears) * task.progress) / 100) * widthYear;
            let styleAfterProgress = {
                backgroundImage:
                    "radial-gradient(circle, " +
                    task.styles.progressColor +
                    " 20%, transparent 10%), radial-gradient(circle, " +
                    task.styles.progressColor +
                    " 20%, transparent 10%)",
                width:widthAfterProgress,
                minWidth:widthAfterProgress,
            };
            let toolTip =
                t(`SUMP Management Content.tasks.${task.name}`) +
                " ( " +
                task.progressReal +
                "% )";
            htmlYears.push(
                <LightTooltip title={toolTip} key={task.id} arrow>
                    <div
                        className="gantt-task-container"
                        style={styleContainer}
                    >
                        <div
                            className="gantt-task-before-progress"
                            style={styleBeforeProgress}
                        ></div>
                        <div
                            className="gantt-task-after-progress"
                            style={styleAfterProgress}
                        ></div>
                        <div
                            className="gantt-task-progress-real"
                            style={styleContainerProgressReal}
                        ></div>
                    </div>
                </LightTooltip>,
            );
            htmlTask = (
                <div className="gantt-task">
                    <div className="gantt-task-title">
                        {t(`SUMP Management Content.tasks.${task.name}`)}
                    </div>{" "}
                    {htmlYears}
                </div>
            );
        }
        htmlTasks.push(htmlTask);
    });

    return (
        <>
            {htmlTasks.length > 0
                ? htmlTasks.map((task, index) => <div key={index}>{task}</div>)
                : ""}
        </>
    );
}

GanttMyc.propTypes = {
  tasks: PropTypes.array.isRequired,
  startYear: PropTypes.number.isRequired,
  endYear: PropTypes.number.isRequired,
};
